import { Checkbox, Select, Space, Divider, Tag } from "antd";
import { useEffect, useState } from "react";
import clsx from 'clsx';
import { useTranslation } from "react-i18next";

export const MulitpleSelectAtomic = ({ handleOptionsChange, optionsData, defaultValue, isToDisable, size, fullWidth, placeholder, ...props }) => {
    // Hook de tradução
    const { t } = useTranslation();

    const [selectedOption, setSelectedOption] = useState(defaultValue);
    const checkAll = optionsData.length === selectedOption?.length;

    useEffect(() => {
        if (JSON.stringify(defaultValue) !== JSON.stringify(selectedOption)) {
            setSelectedOption(defaultValue); 
        }
    }, [defaultValue]);

    useEffect(() => {
        try {
            // if(selectedOption){
                handleOptionsChange(placeholder, selectedOption);
            // }
        } catch (error) {
            console.error('(MultipleSelectAtomic page) Error in useEffect slectedOptions:', error);
            //reportError(error); // Send error report to backend
        }
    }, [selectedOption])

    return (
        <Select
            mode="multiple"
            size='large'
            placeholder={<span style={{ color: 'lightgrey' }}>{t(placeholder)}</span>}
            value={selectedOption}
            onChange={(e, record) => { setSelectedOption(e.map(x => { return { label: x, value: x } })); }}
            dropdownRender={menu => (
                <div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 8px 0px 8px' }}>
                        <Checkbox
                            indeterminate={selectedOption?.length > 0 && selectedOption?.length < 3}
                            onChange={(e) => setSelectedOption(e.target.checked ? optionsData.map(x => { return { label: x.value, value: x.value } }) : [])}
                            checked={checkAll}
                        >
                            {t('All')}
                        </Checkbox>
                        <a
                            onClick={() => setSelectedOption([])}
                            style={{ float: 'right', padding: '5px 8px', fontSize: 'x-small' }}>
                            {t('Clear Options')}
                        </a>
                    </div>
                    <Divider style={{ margin: '8px 0' }} />
                    <div style={{ padding: '8px', display: 'flex', flexDirection: 'column', maxHeight: '200px', overflowY: 'auto' }}>
                        {optionsData.map((option) => {
                            return (
                                <Checkbox
                                    key={option.value}
                                    value={option.value}
                                    checked={selectedOption.find(item=> item.value === option.value) ? true : false}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setSelectedOption(prev =>
                                            e.target.checked
                                                ? [...prev, { label: value, value: value }]
                                                : prev.filter(item => item.value !== value)
                                        );
                                    }}
                                    style={{ padding: '5px 0px' }}
                                >
                                    {t(option.label)}
                                </Checkbox>
                            )
                        })}
                    </div>
                </div>
            )}
            className={clsx('multiple-select-atomic', props?.className, fullWidth ? 'full-width' : '')}
            tagRender={props => {
                const { label, value, closable, onClose } = props;
                const renderPlaceholder = selectedOption[0]?.label === label;
                return (
                    <>
                        {renderPlaceholder ? <p style={{ margin: '0 5px', fontSize: 'x-small', color: 'grey' }}>{t(placeholder)}</p> : null}
                        <Tag
                            // color="blue"
                            closable={closable}
                            onClose={onClose}
                            style={{ margin: 2 }}
                        >
                            {t(label)}
                        </Tag>
                    </>
                );
            }}
        >
        </Select>
    );
}